import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class RegExRule implements IValidationRule
{
    public rule: RuleName = 'RegEx';
    private regEx: RegExp;
    private errorLabel: string;

    constructor(regEx: RegExp, validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.regEx = regEx;
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        if (this.regEx?.test(value))
        {
            return '';
        }
        return this.errorLabel;
    }
}
